import * as React from 'react';
import { MapContext, getAMapVerion } from '../Map';
import useBindEvents from '../../hooks/useBindEvents';
import { Events, PathSimplifierOptionsProps, PathNavigatorOptionsProps } from '../../types';

const { useContext, useEffect, useState, useRef } = React;

export interface PathProps {
  data?: any[] | [];
  events?: Events;
  pathSimplifierOptions: PathSimplifierOptionsProps;
  pathSimplifierRef?: (ref: any) => any; 
  pathNavigatorOptions?: PathNavigatorOptionsProps;
  animate?: boolean;
  fitAvoid?: any;
}

const requireMapUi = (callback: (params: any) => any) => {
  if (!(window as any).AMapUI) {
    if (!(window as any).AMapVersion || !(window as any).AMapKey) {
      throw new Error('Please use method setAMapVersion、setAMapKey, set AMap Version and Key!');
    }

    const url = `https://webapi.amap.com/ui/1.0/main.js?v=${getAMapVerion()}`;

    const jsapi = document.createElement('script');

    jsapi.addEventListener('load', (e) => {
      callback((window as any).AMapUI);
    });

    jsapi.charset = 'utf-8';
    jsapi.src = url;
    document.head.appendChild(jsapi);
  } else {
    callback((window as any).AMapUI);
  }
}

function PathSimplifierCom(props: PathProps) {
  const { data, events, pathSimplifierOptions, animate, pathNavigatorOptions, pathSimplifierRef, fitAvoid } = props;
  const [isInit, setIsInit] = useState(false);
  const pathIns: any = useRef(null);
  const map = useContext(MapContext);
  const [path, setPath]: [any, any] = useState(null);

  useBindEvents(path, events);

  useEffect(() => {
    if(!map) return;
    requireMapUi((mapUi: any) => {
      mapUi.load(['ui/misc/PathSimplifier', 'lib/$'], (PathSimplifier: any, $: any) => {
        if (!PathSimplifier.supportCanvas) {
          alert('当前环境不支持 Canvas！');
          return;
        }
  
        const pathSimplifierIns: any = new PathSimplifier({...pathSimplifierOptions, map});
        pathIns.current = pathSimplifierIns;
        // useBindEvents(pathSimplifierIns, events);
        setPath(pathSimplifierIns);
        pathSimplifierRef && pathSimplifierRef(pathSimplifierIns);
        setIsInit(true)
      });
    })
  }, [map])

  useEffect(() => {
    if (!map || !isInit) {
      return;
    }
    pathIns.current.setData(data);
    if(animate) {
      const L = (data as []).length || 0;
      for(let i =0; i < L; i++) {
        // 对第一条线路（即索引 0）创建一个巡航器
        const p = pathIns.current.createPathNavigator(i, pathNavigatorOptions);
        p.moveByDistance(100);
        p.start();
      }
    }
    // hack 调整地图上覆盖物的可视范围
    if(fitAvoid) {
      (map as any).setFitView(null, false, fitAvoid);
    }
  }, [data, isInit, map]);

  return null;
}

export default PathSimplifierCom;
